import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import { useNavigate } from "react-router-dom";
import { EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import UnDeleteButton from "components/Button/UnDeleteButton";
import { useModal } from "context/ModalContext";
import { UserService } from "services/UserService/UserService";
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards";

export default function UserForm(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchInsertUser, fetchUpdateUser, fetchDeleteUser, fetchUserById, fetchCheckIsAdmin } = UserService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")
    
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [password, setPassword] = useState(EmptyString)
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errorUsername, setErrorUsername] = useState(false)
    const [errorName, setErrorName] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)
    
    // Button Event
    const saveBtnClick = async () => {
        if(!fFormValidation()) return 
        
        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            if (formType === FormTypeAdd) {
                const res = await fetchInsertUser(username, name, password, isAdmin)
                if (!res) return
            } else {
                const res = await fetchUpdateUser(paramUserId, username, name, password, isAdmin)
                if (!res) return
            }

            showSuccess({
                onSuccess: () => {
                    navigate("/setting/user")
                }
            })
        }
        finally {
            hideLoading()
        }
    }
    const deleteBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = await fetchDeleteUser(paramUserId, status === 1 ? '2' : '1')
            if (!res) return 

            showSuccess({
                onSuccess: () => {
                    navigate("/setting/user")
                }
            })
        }
        finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (username === EmptyString || username === null){
            setErrorUsername(true)
            errorCount++
        }else{
            setErrorUsername(false)
        }

        if (name === EmptyString || name === null){
            setErrorName(true)
            errorCount++
        }else{
            setErrorName(false)
        }

        if (password === EmptyString || password === null){
            setErrorPassword(true)
            errorCount++
        }else{
            setErrorPassword(false)
        }

        if (confirmPassword === EmptyString || confirmPassword === null){
            setErrorConfirmPasswordMessage("Confirm Password is required")
            setErrorConfirmPassword(true)
            errorCount++
        }else{
            setErrorConfirmPassword(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }
    
    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                const res = await fetchCheckIsAdmin(localStorage.getItem("Id"))
                if (!res) return 

                if (formType === FormTypeEdit){
                    const res = await fetchUserById(paramUserId)
                    if (!res) return

                    let data = res.data

                    setUsername(data.username)
                    setName(data.fullName)
                    setIsAdmin(data.isAdmin)
                    setStatus(data.status)
                    setCreateDate(data.createdDate)
                    setUpdateDate(data.updatedDate)
                    setUpdateBy(data.updatedBy)
                }
            }
            finally {
                hideLoading()
            }
        }
        
        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <div>
                <PagesFormTitle 
                    title='User Detail'
                    formType={formType}
                    status={status}
                    createDate={createDate}
                    updateDate={updateDate}
                    updateBy={updateBy}
                />

                <div className="mt-5 flex flex-col gap-3 text-sm">
                    {/* <FormCard title='Username'>
                        <input className="input" value={ username } onChange={(e) => { setUsername(e.target.value) }} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                    </FormCard> */}
                    {/* Username */}
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48">
                                <span>Username</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input w-full sm:w-72" value={ username } onChange={(e) => { setUsername(e.target.value) }} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                            </div>
                        </div>
                        <div className={`flex items-center ${errorUsername ? 'block' : 'hidden'}`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Username is required!</span>
                        </div>
                    </div>

                    {/* Name */}
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48">
                                <span>Name</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} maxLength={30} />
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorName ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Name is required!</span>
                        </div>
                    </div>

                    {/* Password */}
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48">
                                <span>Password</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input type="password" className="input" value={password} onChange={(e) => { setPassword(e.target.value) }} />
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorPassword ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Password is required!</span>
                        </div>
                    </div>

                    {/* Confirm Password */}
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48">
                                <span>Confirm Password</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input type="password" className="input" value={confirmPassword} onChange={(e) => {setConfirmPassword(e.target.value)}} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} />
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorConfirmPassword ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">{ errorConfirmPasswordMessage }</span>
                        </div>
                    </div>

                    {/* Admin */}
                    <div>
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>Admin</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 flex items-center">
                                <input type="checkbox" className="" value={isAdmin} onChange={(e) => {setIsAdmin(!isAdmin)}} checked={isAdmin} />
                            </div>
                        </div>
                    </div>

                    {/* Button */}
                    <div className="mt-5 flex flex-wrap justify-end gap-2">
                        <SaveButton onClick={saveBtnClick} visible={true} />
                        <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === '1' ? true : false) : false} />
                        <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === '2' ? true : false) : false} />
                        <BackButton onClick={backBtnClick} />
                    </div>
                </div>
            </div>            
        </MainBodyCard>
    )
}